module.exports = __webpack_public_path__ + "static/media/logo.9bfc434c.png";